import React from 'react';
import { Component } from 'react';
import "./TermsPage.scss";
import TermsScreen from '../../components/screens/Terms/TermsScreen';
import ContactScreen from '../../components/screens/Contact/ContactScreen';

type TermsPageProps = {
};

export default class TermsPage extends Component<TermsPageProps> {
    public render() {
        return (
            <div>
                <div className="background"></div>
                <div className="web-container terms">

                    <section id="terms">
                        <TermsScreen />
                    </section>

                    <section id="contact">
                        <ContactScreen
                        header="Skontaktuj się z nami"
                        />
                    </section>
                </div>
            </div>
        )
    }
}